import { createBrowserRouter, RouterProvider } from 'react-router';
import * as Sentry from '@sentry/react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import theme from '@motorcade/portal/src/MotorcadeTheme';
import { ToastContainer } from 'react-toastify';
import Routes from '@motorcade/portal/src/Routes';

const App = () => {
	const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);
	const router = sentryCreateBrowserRouter(Routes());

	return (
		<ThemeProvider theme={theme}>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				<CssBaseline />
				<RouterProvider router={router} />
				<ToastContainer hideProgressBar />
			</LocalizationProvider>
		</ThemeProvider>
	);
};

export default App;
